import {assignToHierarchy} from '#core/utils/config-utils.js';
import {SpriteMapStorage} from '#core/utils/spritemap-storage/index.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Dialogs} from '../dialogs.js';

import {betSharingDialogFactory} from './bet-sharing.factory.js';

import PALETTE_SCHEMA from './bet-sharing.palette-schema.yaml';

class BetSharingFeature extends AbstractVisualFeature {
    get name() {
        return 'BetSharing';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return betSharingDialogFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        assignToHierarchy(mojitoConfig, 'services.configurations.ShareDialogFooter', {
            imageOptions: {
                skipFonts: false,
                filter: node => {
                    const {spritePrefix, spriteIdToSpriteHTMLNodeMap} = SpriteMapStorage;

                    if (node instanceof SVGSVGElement) {
                        const spriteUseName = node.querySelector('use')?.getAttribute('xlink:href');
                        const spriteName = spriteUseName.replace(`#${spritePrefix}`, '');
                        const spriteNode = spriteIdToSpriteHTMLNodeMap[spriteName];

                        if (!spriteNode) return false;

                        node.setAttribute('viewBox', spriteNode.getAttribute('viewBox'));
                        node.innerHTML = spriteNode.innerHTML;
                    }

                    return true;
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

if (FEATURES.betSharing) {
    new BetSharingFeature(Dialogs);
}
